import { Link } from 'react-router-dom';
import { FlagTricolorBar } from '@/components/flag-tricolor-bar';
import { ShopGndLogo, LOGO_SIZE_FOOTER } from '@/components/ShopGndLogo';
import { MARKETPLACE } from '@/lib/marketplacePaths';

const shopLinks = [
  { to: MARKETPLACE.shop, label: 'All products' },
  { to: MARKETPLACE.classifieds, label: 'Classifieds' },
  { to: MARKETPLACE.realEstate, label: 'Properties' },
  { to: MARKETPLACE.findAPro, label: 'Find a Pro' },
  { to: MARKETPLACE.vendors, label: 'Vendors' },
  { to: '/boost/', label: 'Deals & Ads' },
];

const sellLinks = [
  { to: '/sell/', label: 'Sell on ShopGND' },
  { to: '/join?intent=sell', label: 'Open your store' },
  { to: '/advertise/', label: 'Advertise' },
  { to: '/join?intent=pro', label: 'Offer services' },
];

const helpLinks = [
  { to: '/about/', label: 'About ShopGND' },
  { to: '/account/orders', label: 'Your orders' },
  { to: '/cart', label: 'Your cart' },
  { to: '/terms/#returns', label: 'Returns policy' },
  { to: '/account/messages', label: 'Messages' },
];

export function Footer() {
  return (
    <footer className="bg-brand-800 text-white">
      <div className="mx-auto max-w-listing px-5 py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr]">

          {/* Brand */}
          <div>
            <ShopGndLogo to="/" className={LOGO_SIZE_FOOTER} />
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-brand-100">
              Grenada marketplace — local vendors, classifieds, property, and trades.
            </p>
            <div className="mt-4">
              <FlagTricolorBar className="w-16" />
            </div>
            <p className="mt-3 text-xs text-white/90">
              Serving Grenada, Carriacou & Petite Martinique.
            </p>
          </div>

          {/* Shop */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-500">
              Shop
            </p>
            <ul className="mt-4 space-y-3">
              {shopLinks.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-brand-100 transition hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sell */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-500">
              Sell
            </p>
            <ul className="mt-4 space-y-3">
              {sellLinks.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-brand-100 transition hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Help */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-500">
              Help
            </p>
            <ul className="mt-4 space-y-3">
              {helpLinks.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-brand-100 transition hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom strip */}
      <div className="bg-brand-900">
        <div className="mx-auto flex max-w-listing flex-col gap-3 px-5 py-4 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between">
          <p className="text-center text-xs text-white/90 sm:text-left">
            © {new Date().getFullYear()} ShopGND · Grenada, West Indies
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-white/90">
            <span>Secure payments</span>
            <span className="hidden sm:inline" aria-hidden>
              ·
            </span>
            <span>Buyer & seller protection</span>
            <span className="hidden sm:inline" aria-hidden>
              ·
            </span>
            <span>Location-aware delivery</span>
          </div>
        </div>
      </div>

      {/* Mobile bottom nav spacer */}
      <div className="h-16 md:hidden" />
    </footer>
  );
}
